import * as types from './types'
import {getPlatformTokenInfo, Utils} from '../../tools/utils';
import { setUser } from '@lima/error-tracking-react'; // 根据自己实际情况使用react/vue

export function setToken (state) {

  setTimeout(() => {
    const data = Utils.getUserData();
    setUser({
      id: data.userId,
      username: data.username,
      mobile: data.mobilePhone,
      email: data.orgId,
      name: data.name,
      orgCname: data.orgCname,
      // 其余信息也可以附加上去
    });
  }, 1000);
  return {
    type: types.SET_TOKEN,
    payload: state
  }
}

export function getToken () {
  return (dispatch, getState) => {
    // !!新登录，token值变更为Authorization的值（type+access-token!!
    let token = getPlatformTokenInfo()['token_type']+getPlatformTokenInfo()['access_token'];
    dispatch(setToken(token));
  }
}
/** 导出为全局方法，依赖于redux*/
export  function  setUserInfo(info) {
    return{
      type:"setUserInfo",
      payload:info
    }
}
// 获取最新的渠道权限
export const changeChannelType = (status) => ({type:"setIsOpenChannel",payload:status})

// 获取最新的商户是不是自媒体商户
export const changeDepartmentOrgType = (status) => ({type:"setIsDepartmentOrg",payload:status})
// 查询当前账号是否为自媒体的仅本人
export const accountIsMyself = (status) => ({type:"setIsMyselfSign",payload:status})


